import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { EventSystemComplete } from "../../../models/event-systems/event-system-complete.model";

export const adminSystemAdapter: EntityAdapter<EventSystemComplete> = createEntityAdapter<EventSystemComplete>({
    selectId: (system) => system.systemID,
    sortComparer: (a,b) => a.name.localeCompare(b.name)
});